// RITA-1585 — Knopf „📖 Handbuch“ oben rechts in der Zeile der Pfadzeile (Vorlagen-Editor und Vertrag am Berater).
// Blau ausgefüllt, solange die Leiste offen ist; derselbe Knopf schließt sie wieder. Unter 900 px Fensterbreite bleibt
// nur das Buch-Symbol, damit die Zeile nicht umbricht (Punkt C der Skizze 31.10.2026). Das Symbol ist das der Kachel
// „Einstellungen › Handbuch“; der barrierefreie Name bleibt „Handbuch“.
import React from 'react';
import { Box, Button } from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';

export const HANDBUCH_KNOPF_TEXT = 'Handbuch';

interface Props {
  offen: boolean;
  onClick: () => void;
}

export default function HandbuchKnopf({ offen, onClick }: Props) {
  return (
    <Button
      size="small"
      variant={offen ? 'contained' : 'outlined'}
      startIcon={<MenuBookIcon />}
      aria-label={HANDBUCH_KNOPF_TEXT}
      aria-pressed={offen}
      onClick={onClick}
      data-testid="handbuch-knopf"
      sx={{
        flexShrink: 0,
        minWidth: 0,
        textTransform: 'none',
        '& .MuiButton-startIcon': { mr: { xs: 0, md: 1 }, ml: { xs: 0, md: -0.5 } },
      }}
    >
      <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
        {HANDBUCH_KNOPF_TEXT}
      </Box>
    </Button>
  );
}
